/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The winner is chosen with your browser's random generator, and every option has an equal chance because all segments are the same size.`)
};

const es_dw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. El ganador se elige con el generador aleatorio de tu navegador, y cada opción tiene la misma probabilidad porque todos los segmentos tienen el mismo tamaño.`)
};

const de_dw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Der Gewinner wird mit dem Zufallsgenerator deines Browsers ausgewählt, und jede Option hat die gleiche Chance, da alle Segmente gleich groß sind.`)
};

const nl_dw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. De winnaar wordt gekozen met de willekeurige generator van je browser, en elke optie heeft een gelijke kans omdat alle segmenten even groot zijn.`)
};

const fr_dw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Le gagnant est choisi avec le générateur aléatoire de votre navigateur, et chaque option a une chance égale car tous les segments ont la même taille.`)
};

const it_dw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Il vincitore viene scelto con il generatore casuale del tuo browser, e ogni opzione ha la stessa probabilità perché tutti gli spicchi hanno la stessa dimensione.`)
};

const pt_br2_dw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. O vencedor é escolhido pelo gerador aleatório do seu navegador, e toda opção tem a mesma chance porque todos os segmentos têm o mesmo tamanho.`)
};

const pt_dw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. O vencedor é escolhido com o gerador aleatório do seu navegador, e todas as opções têm a mesma probabilidade porque todos os segmentos têm o mesmo tamanho.`)
};

const ja_dw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。当選はブラウザの乱数生成機能で選ばれ、すべてのセグメントが同じ大きさなので、どの選択肢も同じ確率になります。`)
};

const zh_dw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的。结果由浏览器的随机数生成器选出，由于所有扇形区域大小相同，每个选项获选的概率都相等。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dw_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dw_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dw_faq_a1", locale)
	if (locale === "en") return en_dw_faq_a1(inputs)
	if (locale === "es") return es_dw_faq_a1(inputs)
	if (locale === "de") return de_dw_faq_a1(inputs)
	if (locale === "nl") return nl_dw_faq_a1(inputs)
	if (locale === "fr") return fr_dw_faq_a1(inputs)
	if (locale === "it") return it_dw_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_dw_faq_a1(inputs)
	if (locale === "pt") return pt_dw_faq_a1(inputs)
	if (locale === "ja") return ja_dw_faq_a1(inputs)
	return zh_dw_faq_a1(inputs)
};